const dndStructure = {
  columns: {
    'available': {id: 'available', title: 'Available', certificationIds: []},
    'selected': {id: 'selected', title: 'Selected', certificationIds: []},
  }
}

export default dndStructure
